import React, { useEffect, useState } from "react";
import API from "../services/api";
import { 
  Users, FileText, CheckCircle, 
  Activity, Zap, ShieldAlert, BarChart3 
} from "lucide-react";

// const VGMLogo = ({ height = 35, textColor = "white" }) => (
//   <svg viewBox="0 0 400 140" height={height} xmlns="http://www.w3.org/2000/svg">
//     <g id="cube-stack">
//       <path d="M40 10 l20 12 v25 l-20 12 l-20 -12 v-25 z" fill="#F7941D" />
//       <path d="M40 10 l-20 12 v25 l20 12 z" fill="#EE3A3B" />
//       <path d="M40 10 l20 12 l-20 12 l-20 -12 z" fill="#FFB85F" />
//       <g transform="translate(0, 35)">
//         <path d="M40 10 l20 12 v25 l-20 12 l-20 -12 v-25 z" fill="#F7941D" /><path d="M40 10 l-20 12 v25 l20 12 z" fill="#EE3A3B" /><path d="M40 10 l20 12 l-20 12 l-20 -12 z" fill="#FFB85F" />
//       </g>
//       <g transform="translate(0, 70)">
//         <path d="M40 10 l20 12 v25 l-20 12 l-20 -12 v-25 z" fill="#F7941D" /><path d="M40 10 l-20 12 v25 l20 12 z" fill="#EE3A3B" /><path d="M40 10 l20 12 l-20 12 l-20 -12 z" fill="#FFB85F" />
//       </g>
//     </g>
//     <text x="90" y="105" fill={textColor} style={{ fontFamily: 'Arial Black', fontWeight: '900', fontSize: '95px', letterSpacing: '-4px' }}>VGM</text>
//   </svg>
// );

function SummaryPage() {
  const [data, setData] = useState({});

  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    try {
      const res = await API.get("/dashboard/summary");
      setData(res.data);
    } catch (err) {
      console.log("Error fetching data:", err);
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.brandGroup}>
          <div className="brand-logo-container">
                <img
                    src="/image.png"
                    alt="VGM Logo"
                    style={{ 
                        height: '70px', 
                        width: 'auto', 
                        objectFit: 'contain',
                        // filter: 'brightness(1) invert(2)' 
                    }}
                />
              </div>
          <div style={styles.divider}></div>
          <h2 style={styles.title}>System Analytics</h2>
        </div>
        <div style={styles.dateTag}>{new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
      </header>

      {/* CHANGED: mainGrid now uses a responsive grid layout to prevent blank space */}
      <div style={styles.mainGrid}>
        
        <Section title="Forms Pipeline" icon={<FileText size={20} color="#fff" />}>
          <Card title="Sent Till Date" value={data.total_forms_sent} icon={<Zap size={14}/>} />
          <Card title="Sent This Month" value={data.forms_sent_this_month} icon={<BarChart3 size={14}/>} />
        </Section>

        <Section title="Submissions" icon={<CheckCircle size={20} color="#10b981" />}>
          <Card title="Total Submitted" value={data.submitted_total} variant="success" />
          <Card title="Monthly Total" value={data.submitted_this_month} variant="success" />
        </Section>

        <Section title="Agent Directory" icon={<Users size={20} color="#818cf8" />}>
          <Card title="Total Agents" value={data.total_agents} />
          <Card title="Monthly Joiners" value={data.agents_this_month} />
        </Section>

        <Section title="Attention Required" icon={<ShieldAlert size={20} color="#fbbf24" />}>
          <Card title="Pending Today" value={data.pending_today} variant="warning" />
        </Section>

        {/* This section is set to span across columns if needed in the grid */}
        <div style={{ gridColumn: "1 / -1" }}>
          <Section title="Network Health" icon={<Activity size={20} color="#f5188a" />}>
            <Card title="Active (All Time)" value={data.active_total} color="#19f505" />
            <Card title="Inactive (All Time)" value={data.inactive_total} color="#f51212" />
            <Card title="Active (Month)" value={data.active_this_month} color="#17fd0f" />
            <Card title="Inactive (Month)" value={data.inactive_this_month} color="hsl(0, 91%, 49%)" />
            <Card title="Admin Approved (Total)" value={data.admin_approved_total} />
<Card title="Admin Approved This Month" value={data.admin_approved_this_month} />
          </Section>
        </div>

      </div>
    </div>
  );
}

const Section = ({ title, icon, children }) => (
  <div style={styles.section}>
    <div style={styles.sectionHeader}>
      {icon}
      <h3 style={styles.sectionTitle}>{title}</h3>
    </div>
    <div style={styles.cardGrid}>{children}</div>
  </div>
);

const Card = ({ title, value, variant, color, icon }) => {
  const getBorderColor = () => {
    if (variant === "success") return "rgba(16, 185, 129, 0.2)";
    if (variant === "warning") return "rgba(251, 191, 36, 0.2)";
    return "rgba(255, 255, 255, 0.05)";
  };

  return (
    <div style={{ ...styles.card, borderColor: getBorderColor() }}>
      <div style={styles.cardTop}>
        <span style={styles.cardLabel}>{title}</span>
        {icon && <span style={{opacity: 0.5}}>{icon}</span>}
      </div>
      <p style={{ ...styles.value, color: color || styles.value.color }}>
        {value ?? 0}
      </p>
    </div>
  );
};

const styles = {
  container: {
    padding: "40px",
    background: "#214f57",
    backgroundImage: "radial-gradient(at 0% 0%, hsla(215, 98%, 61%, 0.07) 0, transparent 50%), radial-gradient(at 100% 100%, hsla(215, 98%, 61%, 0.07) 0, transparent 50%)",
    minHeight: "100vh",
    color: "#f8fafc",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "50px",
  },
  brandGroup: { display: "flex", alignItems: "center", gap: "20px" },
  divider: { width: "1px", height: "30px", background: "rgba(252, 244, 244, 0.97)" },
  title: { fontSize: "20px", fontWeight: "600", letterSpacing: "-0.5px", color: "#fff" },
  dateTag: { fontSize: "12px", background: "rgba(250, 241, 241, 0.96)", padding: "6px 12px", borderRadius: "100px", color: "#64748b", border: "1px solid rgba(255,255,255,0.05)" },
  
  // FIXED: Changed from column flex to a 2-column grid
  mainGrid: { 
    display: "grid", 
    gridTemplateColumns: "repeat(2, 1fr)", 
    gap: "40px",
    alignItems: "start" 
  },
  
  section: { width: "100%" },
  sectionHeader: { display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" },
  sectionTitle: { fontSize: "14px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1.5px", color: "#fff" },
  
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "20px",
  },
  card: {
    padding: "24px",
    borderRadius: "20px",
    background: "rgba(135, 195, 197, 0.65)",
    backdropFilter: "blur(10px)",
    border: "1px solid",
    transition: "all 0.3s ease",
  },
  cardTop: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" },
  cardLabel: { fontSize: "13px", color: "#e0f6fc", fontWeight: "500" },
  value: { fontSize: "32px", fontWeight: "800", color: "#f8fafc", letterSpacing: "-1px" },
};

export default SummaryPage;